"use client"

import { Spotlight } from "@/components/ui/Spotlight"
import { Shield, Database, Cpu } from "lucide-react"
import { useTranslations } from "next-intl"

export function TechLabHero() {
  const t = useTranslations("techLab.hero")
  
  return (
    <section className="relative w-full pb-16 pt-36">
      {/* Spotlights - full width */}
      <div className="absolute inset-0 overflow-hidden">
        <Spotlight
          className="-top-40 -left-10 md:-left-32 md:-top-20 h-screen"
          fill="white"
        />
        <Spotlight
          className="h-[80vh] w-[50vw] top-10 left-[60%]"
          fill="hsl(220 14% 40%)"
        />
      </div>

      {/* Background grid - full width */}
      <div
        className="absolute inset-0 w-full h-[50vh] dark:bg-background bg-white dark:bg-grid-white/[0.02] bg-grid-black/[0.2]"
      >
        <div
          className="absolute pointer-events-none inset-0 dark:bg-background
          bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)]"
        />
      </div>

      {/* Content - centered */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center lg:text-left">
        <div className="flex items-center gap-2 mb-4">
          <span className="text-slate-400 text-sm font-medium uppercase tracking-widest">
            {t("sectionLabel")}
          </span>
          <span className="w-2 h-2 rounded-full bg-slate-400/50" />
          <span className="text-muted-foreground/60 text-sm">{t("technologySolutions")}</span>
        </div>
        
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
          {t("title")}
        </h1>
        
        <p className="text-muted-foreground text-lg md:text-xl leading-relaxed mb-8 max-w-3xl">
          {t("subtitle")}
        </p>

        {/* Key features */}
        <div className="grid sm:grid-cols-3 gap-6 text-left">
          <div className="flex items-start gap-3 p-4 rounded-xl bg-card/30 border border-border/50">
            <Shield className="w-5 h-5 text-slate-400 mt-0.5 shrink-0" />
            <div>
              <h4 className="font-medium text-foreground text-sm">{t("strictMode.title")}</h4>
              <p className="text-muted-foreground text-xs mt-1">{t("strictMode.description")}</p>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 rounded-xl bg-card/30 border border-border/50">
            <Database className="w-5 h-5 text-slate-400 mt-0.5 shrink-0" />
            <div>
              <h4 className="font-medium text-foreground text-sm">{t("topologicalMemory.title")}</h4>
              <p className="text-muted-foreground text-xs mt-1">{t("topologicalMemory.description")}</p>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 rounded-xl bg-card/30 border border-border/50">
            <Cpu className="w-5 h-5 text-slate-400 mt-0.5 shrink-0" />
            <div>
              <h4 className="font-medium text-foreground text-sm">{t("agenticArchitecture.title")}</h4>
              <p className="text-muted-foreground text-xs mt-1">{t("agenticArchitecture.description")}</p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  )
}
